export const navbarData = [
  {
    title: "Home",
    link: "/home",
    icon: "fa-solid fa-house",
  },
  {
    title: "Bookmarks",
    link: "/bookmarks",
    icon: "fa-solid fa-bookmark",
  },
  {
    title: "Explore",
    link: "/explore",
    icon: "fa-solid fa-compass",
  },
  {
    title: "Profile",
    link: "/profile",
    icon: "fa-solid fa-user",
  },
];
